import React, { createContext, useMemo, useState } from 'react';

type KnowledgeProductsYearFilterContextType = {
  selectedYear: number;
  setSelectedYear: (year: number) => void;
  availableYears: number[];
  setAvailableYears: (years: number[]) => void;
  selectedProductTypeId: number;
  setSelectedProductTypeId: (productTypeId: number) => void;
  availableProductTypes: Array<{ id: number; label: string }>;
  setAvailableProductTypes: (types: Array<{ id: number; label: string }>) => void;
};

export const KnowledgeProductsYearFilterContext = createContext<KnowledgeProductsYearFilterContextType>({
  selectedYear: 0,
  setSelectedYear: () => {},
  availableYears: [],
  setAvailableYears: () => {},
  selectedProductTypeId: 0,
  setSelectedProductTypeId: () => {},
  availableProductTypes: [],
  setAvailableProductTypes: () => {},
});

export const KnowledgeProductsYearFilterProvider: React.FC = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState<number>(0);
  const [availableYears, setAvailableYears] = useState<number[]>([]);
  const [selectedProductTypeId, setSelectedProductTypeId] = useState<number>(0);
  const [availableProductTypes, setAvailableProductTypes] = useState<Array<{ id: number; label: string }>>([]);

  const value = useMemo(
    () => ({
      selectedYear,
      setSelectedYear,
      availableYears,
      setAvailableYears,
      selectedProductTypeId,
      setSelectedProductTypeId,
      availableProductTypes,
      setAvailableProductTypes,
    }),
    [selectedYear, availableYears, selectedProductTypeId, availableProductTypes],
  );

  return (
    <KnowledgeProductsYearFilterContext.Provider value={value}>
      {children}
    </KnowledgeProductsYearFilterContext.Provider>
  );
};
